import React, { useState } from 'react';
import { BackButton } from '../buttons/backButton';
import { ContinueButton } from '../buttons/continueButton';
import { StartButton } from "../buttons/startbutton";
import explanation0 from "./pictures/explanation0.JPG";
import explanation1 from "./pictures/explanation1.JPG";
import explanation2 from "./pictures/explanation2.JPG";
import explanation3 from "./pictures/explanation3.JPG";
import explanation4 from "./pictures/explanation4.JPG";
import explanation5 from "./pictures/explanation5.JPG";
import explanation6 from "./pictures/explanation6.JPG";
import explanation7 from "./pictures/explanation7.JPG";
import { useNavigate } from "react-router-dom";

/**
 * @author: Alisa Münsterberg
 * @date: 2022-10-14
 */

export default function Explanation() {
    const [currentState, setState] = useState({
        pictures: [explanation0, explanation1, explanation2, explanation3, explanation4, explanation5, explanation6, explanation7],
        currentPicture: explanation0,
        clickCount: 0
    })

    const navigate = useNavigate();


    /*
    * Displays the next picture of the explanation when the ContinueButton was clicked.
    * If the last picture was already on display, reroutes to the practice component.
    */
    const continueExplanation = () => {
        if (currentState.clickCount >= currentState.pictures.length - 1) {
            navigate('/practice');
        }
        setState({ ...currentState, clickCount: currentState.clickCount + 1, currentPicture: currentState.pictures[currentState.clickCount+1] }
        );
    }

    /*
    * Displays the previous picture of the explanation when the BackButton was clicked.
    * If the first picture was already on display, reroutes to the startpage component.
     */
    const reverseExplanation = () => {
        if (currentState.clickCount === 0) {
            navigate('/');
        }
        setState({ ...currentState, clickCount: currentState.clickCount - 1, currentPicture: currentState.pictures[currentState.clickCount-1]})
        
    }

    /*
    * Renders and returns the Explanation component when the user clicks an ExplanationButton 
    * or loads the app with its path extension.
    */

    return (
        <div className='App'>
            <StartButton />
            <img src={currentState.currentPicture} style={{ margin: 10 }} alt={"Teil der Erklärung des Bubblesort-Algorithmus."} />
            <div className="App-buttons">
                <BackButton onClick={reverseExplanation} />
                <ContinueButton onClick={continueExplanation} />
            </div>
        </div>
    )
}